import type { FaireCollectionEntity } from "../../entity_types/collection";

export const pbc_sww6rmn8k9: FaireCollectionEntity = {
  token: "pbc_sww6rmn8k9",
  type: "collection",
  name: "Classic Dove White Knits Baby Collection",
  heroImageUrl:
    "https://cdn.faire.com/fastly/c71ccc281e443beec4936ca7640b9927d683d81e2614779fdade7b50187ac404.png",
  itemCount: 11,
  description:
    "Thoughtfully crafted from 100% certified organic cotton, each heirloom-quality piece features soft, breathable knits in a versatile dove white hue designed to mix, match, and cherish for generations.",
  brandToken: "b_7fghelgl",
  productTokens: [],
  meta: {
    source: "api",
    importedAt: "2026-08-11T04:59:16.704Z",
    importedBy: "entity-db-import-collections",
  },
};
